export default {
  VITE_AUTH0_AUDIENCE: import.meta.env.VITE_AUTH0_AUDIENCE,
  VITE_AUTH0_DOMAIN: import.meta.env.VITE_AUTH0_DOMAIN,
  VITE_AUTH0_CLIENT_ID: import.meta.env.VITE_AUTH0_CLIENT_ID,
  VITE_PARACHUTE_API_ENDPOINT: import.meta.env.VITE_PARACHUTE_API_ENDPOINT,
  VITE_PARACHUTE_REST_API_ENDPOINT: import.meta.env.VITE_PARACHUTE_REST_API_ENDPOINT,
  VITE_NODE_ENV: import.meta.env.VITE_NODE_ENV,
  VITE_SENTRY_DEBUG: import.meta.env.VITE_SENTRY_DEBUG,
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  VITE_ENABLE_TANSTACK_DEVTOOLS: import.meta.env.VITE_ENABLE_TANSTACK_DEVTOOLS,
  VITE_IQ_DOMAIN: import.meta.env.VITE_IQ_DOMAIN,
  VITE_ENABLE_LOGROCKET: import.meta.env.VITE_ENABLE_LOGROCKET,
  VITE_LOGROCKET_ROOT_HOSTNAME: import.meta.env.VITE_LOGROCKET_ROOT_HOSTNAME,
  VITE_ENABLE_HUDL_LOGIN: import.meta.env.VITE_ENABLE_HUDL_LOGIN,
  VITE_HUDL_URL: import.meta.env.VITE_HUDL_URL,
  VITE_VIDEO_SERVICE_URL: import.meta.env.VITE_VIDEO_SERVICE_URL,
  VITE_HUDL_SERVICE_HOST: import.meta.env.VITE_HUDL_SERVICE_HOST,
  VITE_HUDL_SERVICE_KEY: import.meta.env.VITE_HUDL_SERVICE_KEY,
  VITE_HUDL_SERVICE_CERTIFICATE: import.meta.env.VITE_HUDL_SERVICE_CERTIFICATE,
  VITE_AI_SUMMARY_AGENT_ENDPOINT: import.meta.env.VITE_AI_SUMMARY_AGENT_ENDPOINT,
  VITE_AI_FILTER_PROMPT_AGENT_ENDPOINT: import.meta.env.VITE_AI_FILTER_PROMPT_AGENT_ENDPOINT,
  DEV: import.meta.env.DEV,
  VITE_TITLE_PREFIX: import.meta.env.VITE_TITLE_PREFIX,
};
